import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import AirportDrawer from "components/drawer/AirportDrawer";
import BasicMarginDrawer from "components/drawer/BasicMarginDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import EditDeleteButton from "components/table/EditDeleteButton";
import useToggleDrawer from "hooks/useToggleDrawer";

const BasicMarginTable = ({
  basiMarginData,
  hideEdit,
}) => {
  const {
    title,
    serviceId,
    handleModalOpen,
    handleUpdate,
    isSubmitting,
  } = useToggleDrawer();

  return (
    <>
      <DeleteModal
        id={serviceId}
        title={title}
      />

      <MainDrawer>
        <BasicMarginDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {basiMarginData?.map((data, index) => (
          <TableRow key={data.id}>
            <TableCell className="text-center text-xs">
              {index + 1}
            </TableCell>

            <TableCell className="text-center text-xs font-medium">
              {data.city_name}
            </TableCell>

            {Object.entries(data.margin_details || {}).map(
              ([vehicleId, vehicle]) => (
                <TableCell
                  key={vehicleId}
                  className="text-center text-xs"
                >
                  {vehicle.fee}
                </TableCell>
              )
            )}

            <TableCell>
              <div className="flex justify-center">
                <EditDeleteButton
                  id={data.id_city}
                  isSubmitting={isSubmitting}
                  handleUpdate={handleUpdate}
                  handleModalOpen={handleModalOpen}
                  hideEdit={hideEdit}
                />
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default BasicMarginTable;